module.exports = __webpack_public_path__ + "img/icon-key.b8ca71b5.svg";